import React from "react";
import PagebuilderHelper from "../../PagebuilderHelper";

function PreviewImage(props) {
  const element = props.element;

  return (
    <div
      className={`pagebuilder-element-preview pagebuilder-element-preview-image`}
    >
      {PagebuilderHelper.getPreview(element)}
    </div>
  );
}

export default PreviewImage;
